import { useParams } from 'react-router';
import { ScreenLoading } from '@/components/loading';
import { ScreenError, screenErrorKind } from '@/components/screen-error';
import { ScreenAppDetail } from '@/components/screens/detail-screen';
import { useApplication, useMe } from '@/hooks/use-applications';
import { useScreenProps } from '@/store/theme';

export function DetailPage() {
  const sp = useScreenProps();
  const { slug } = useParams<{ slug: string }>();
  const { data: app, isLoading, isError, error, refetch, isFetching } = useApplication(slug);
  // Sem isto a Sidebar cai no default 'admin' e o colaborador que chega por link
  // direto enxerga o menu de administração inteiro.
  const { data: me } = useMe();
  const role = me?.role === 'admin' ? 'admin' : 'collab';

  if (isLoading) return <ScreenLoading dark={sp.dark} />;

  // Falha ou slug inválido: cartão de erro com navegação, nunca um spinner
  // rodando para sempre com o rótulo de "não encontrada". A cópia específica só
  // entra no 404; permissão, rede e erro de servidor mantêm o texto do próprio
  // ScreenError.
  if (isError || !app) {
    const failure = error ?? new Error('Aplicação não encontrada');
    const missing = screenErrorKind(failure) === 'notFound';
    return (
      <ScreenError
        error={failure}
        onRetry={slug ? () => void refetch() : undefined}
        retrying={isFetching}
        active="inventory"
        role={role}
        title="Aplicação"
        breadcrumb={['Administração', 'Inventário']}
        heading={missing ? 'Aplicação não encontrada' : undefined}
        description={
          missing
            ? 'Esta aplicação pode ter sido removida do inventário ou o link que você abriu está desatualizado.'
            : undefined
        }
      />
    );
  }

  return (
    <div style={{ height: 'var(--app-vh)', overflow: 'hidden' }}>
      <ScreenAppDetail {...sp} app={app} role={role} />
    </div>
  );
}
